var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'dark-mode': _vm.isDarkMode },attrs:{"id":"app"}},[_c('MaintenanceBanner',{attrs:{"src":_vm.MAINTENANCE_BANNER_SRC}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }